import React from 'react';
import { FiAlertTriangle } from 'react-icons/fi';

interface ErrorDisplayProps {
  message: string;
}

export const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ message }) => (
  <div className="flex items-center justify-center h-full min-h-screen bg-card-color-200 dark:bg-gray-900">
    <div className="flex flex-col items-center gap-4 text-red-500 bg-red-50 dark:bg-red-900/20 p-8 rounded-lg border border-red-200 dark:border-red-800">
      <FiAlertTriangle className="text-4xl" />
      <h2 className="text-lg font-bold">Failed to Load Data</h2>
      <p className="text-sm text-red-700 dark:text-red-400 max-w-md text-center">{message}</p>
    </div>
  </div>
);